/**
 * counter on click
 * @module counter
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'counter';
export const CLICK_HANDLER = 'click';

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
let $counter = 1;
const $counterVal = $('.js-counter-value');

const counterAddHandler = ($el) => {
  const $countAddTarget = $('.js-counter-add');
  const $counterAdd = $($el.data('counter-add'));
  if (parseInt($counterAdd.text(), 5) <= 5) {
    $counter += 1;
    $counterVal.text(() => $counter);
    if (parseInt($counterAdd.text(), 10) === 5) {
      $counterVal.text(() => $counter);
      $countAddTarget.attr('disabled', true);
    }
  } else {
    $counterVal.text(() => $counter);
    $countAddTarget.attr('disabled', false);
  }
};

const counterSubHandler = ($el) => {
  const $countSubTarget = $('.js-counter-sub');
  const $counterSub = $($el.data('counter-sub'));
  if (parseInt($counterSub.text(), 10) > 1) {
    $counter -= 1;
    $counterVal.text(() => $counter);
    $el.removeAttr('disabled');
  }
  if (parseInt($counterSub.text(), 10) < 2) {
    $counterVal.text(() => $counter);
    $countSubTarget.attr('disabled', true);
  } else {
    $counterVal.text(() => $counter);
    $countSubTarget.attr('disabled', false);
  }
};

const setEventListeners = ($el, options) => {
  $el.on(CLICK_HANDLER, () => {
    counterAddHandler($el, options);
    counterSubHandler($el, options);
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function counter(el, options = {}) {
  const $el = $(el);
  setEventListeners($el, options);
}
registerJQueryPlugin(PLUGIN_NAME, counter);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/counter.js